import Toastify from 'toastify-js'
import '../css/toastify.css'

const colors = {
    danger: "#dc3545",
    success: "#7CE800",
    warning: "#ffc107",
}

export function showToastNotification(description, background, textColor, icon) {
    Toastify({
        text: `<strong>DrinkApp</strong><br>${description}`,
        duration: 4000,
        avatar: icon,
        close: false,
        gravity: "top",
        position: "center",
        stopOnFocus: false,
        escapeMarkup: false,
        style: {
            background: colors[background],
            color: textColor,
        },
        offset: {
            y: -15//-15 because 15 is the default y transformation applied to the toast div
        },
    }).showToast();
}